module.exports = __webpack_public_path__ + "media/images/elta-04eb0823.png";